import MainLayout from "../../../layouts/main/main_layout";
import HospitalLayout from "../../../layouts/hospitals/hospital_layout";
import {
  createHospitalScheme,
  deleteHospitalScheme,
  getHospitalSchemes,
  updateHospitalScheme,
} from "../../../services/hospitals/hospitals";
import HospitalMasterList from "../components/hospital_master_list/hospital_master_list";

export default function HospitalSchemes() {
  return (
    <MainLayout>
      <HospitalLayout>
        <HospitalMasterList
          itemLabel="Scheme"
          itemLabelPlural="Schemes"
          queryKey="hospital-schemes"
          getItems={getHospitalSchemes}
          createItem={createHospitalScheme}
          updateItem={updateHospitalScheme}
          deleteItem={deleteHospitalScheme}
        />
      </HospitalLayout>
    </MainLayout>
  );
}
